import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/AddressInput' /* webpackChunkName: "AddressInput" */),
    import(
      './viewer/AddressInput.controller' /* webpackChunkName: "AddressInput" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('AddressInput', UiTypes),
};

export default entry;
